import { Button, Card, CardBody, Pill } from '@/shared/components';
import type { InvoiceTemplateResponse } from '@/shared/api';
import { InvoiceIssuerHint } from './InvoiceIssuerHint';

interface Props {
  template: InvoiceTemplateResponse;
  busy: boolean;
  onSetPrimary: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

/**
 * Eine Rechnungsvorlage in der Liste.
 *
 * <p>Die drei Aktionen lagen bis Sprint 55 in einer `flex-none`-Zeile neben dem Namen — auf
 * 360 px schoben sie den Namen aus der Karte. Unter `sm` stehen sie jetzt unter den Stammdaten
 * und tragen die volle Breite.</p>
 */
export function InvoiceTemplateCard({ template, busy, onSetPrimary, onEdit, onDelete }: Props) {
  return (
    <Card>
      <CardBody className="flex flex-col gap-3 p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-ink font-serif text-lg">{template.name}</span>
            {template.isPrimary && (
              <Pill variant="accent" size="sm">
                Standardvorlage
              </Pill>
            )}
          </div>
          <p className="text-ink-soft mt-1 truncate text-xs">
            {template.companyName ?? 'Kein Firmenname hinterlegt'}
            {template.billingCity ? ` · ${template.billingCity}` : ''}
            {template.iban ? ` · IBAN ${template.iban.slice(0, 8)}…` : ''}
          </p>
          <InvoiceIssuerHint missing={template.missingIssuerFields} />
        </div>
        <div className="flex flex-wrap items-center gap-2 sm:flex-none">
          {!template.isPrimary && (
            <Button variant="ghost" className="min-h-11" onClick={onSetPrimary} disabled={busy}>
              Zur Standardvorlage machen
            </Button>
          )}
          <Button variant="ghost" className="min-h-11" onClick={onEdit}>
            Bearbeiten
          </Button>
          <Button variant="ghost" className="hover:text-sealwax min-h-11" onClick={onDelete}>
            Löschen
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
